export default "/images/vendor/@coreui/icons/svg/flag/cif-la.svg?ec47c3dfc4e6cb9f5afbdd77c29e28ea";